import { useEffect } from 'react';
import { Provider } from 'react-redux';
import { RouterProvider } from 'react-router-dom';
import { applyColorScheme } from '@platform/core/lib/colorScheme';
import { setupI18n } from '@platform/i18n';
import { registerModuleGroups } from '@platform/modularity';
import { moduleGroups } from '@modules';
import { hydrateStore, store } from '@platform/state/store';
import { router } from './router';

registerModuleGroups(moduleGroups);
hydrateStore();
setupI18n(store.getState().session.lang);

/** Корінь застосунку: сховище Redux і роутер (v7_startTransition — оновлення стану навігації в React.startTransition, як у React Router v7). */
export function App() {
  useEffect(() => {
    applyColorScheme(store.getState().session.colorScheme);
  }, []);
  return (
    <Provider store={store}>
      <RouterProvider router={router} future={{ v7_startTransition: true }} />
    </Provider>
  );
}
